/* "Riktig lader til dette batteriet" — charger attach block on battery PDPs.
 * Hard rules (safety first): the battery's voltage must be among the
 * charger's voltages AND the battery's chemistry must be in the charger's
 * EXPLICIT chemistry-support list (strict — no family loosening; the data
 * side already dropped negated claims like DECA's "ikke egnet til AGM/GEL").
 * Soft rule: charge current 10-20% of capacity, widened to 8-25% only when
 * the strict band is empty. Declared Ah-ranges are respected when present.
 * Top 3, available first, closest to 15% of Ah. Live price, 404-hide. */
(function () {
  'use strict';

  var root = document.getElementById('pv-cm');
  if (!root) return;

  var SV = document.documentElement.lang === 'sv';
  var v = parseInt(root.dataset.voltage, 10);
  var chem = root.dataset.chem;
  var ah = parseFloat(root.dataset.ah);
  if (!v || !chem || !ah) return;

  fetch(root.dataset.jsonUrl, { cache: 'no-cache' })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (data) {
      var pool = (data.chargers || []).filter(function (c) {
        if (c.volts.indexOf(v) === -1) return false;
        if (c.chems.indexOf(chem) === -1) return false;
        if (c.ahMin && ah < c.ahMin) return false;
        if (c.ahMax && ah > c.ahMax) return false;
        return true;
      });
      var band = function (lo, hi) {
        return pool.filter(function (c) { return c.amp >= lo * ah && c.amp <= hi * ah; });
      };
      var list = band(0.10, 0.20);
      if (!list.length) list = band(0.08, 0.25);
      if (!list.length) return; // section stays hidden
      var ideal = 0.15 * ah;
      list.sort(function (a, b) {
        if (a.available !== b.available) return a.available ? -1 : 1;
        return Math.abs(a.amp - ideal) - Math.abs(b.amp - ideal);
      });
      var grid = document.getElementById('pv-cm-grid');
      list.slice(0, 3).forEach(function (c) { grid.appendChild(card(c)); });
      root.hidden = false;
      observe(grid);
    })
    .catch(function () { /* leave hidden */ });

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function card(c) {
    var li = document.createElement('li');
    li.className = 'pv-bf__item card-wrapper';
    li.dataset.handle = c.handle;
    var specs = [c.volts.join('/') + 'V', c.amp + 'A'];
    if (c.channels) specs.push(c.channels + ' kanaler');
    li.innerHTML =
      '<div class="card pv-bf__card">' +
        '<a class="pv-bf__cardlink full-unstyled-link" href="/products/' + c.handle + '">' +
          '<div class="pv-bf__media">' +
            (c.img ? '<img src="' + c.img + '" loading="lazy" alt="' + esc(c.title) + '" width="180" height="180">' : '') +
            (!c.available ? '<span class="pv-bf__badge pv-bf__badge--oos">' + (SV ? 'Slut i lager' : 'Utsolgt') + '</span>' : '') +
          '</div>' +
          '<div class="card__content pv-bf__content">' +
            '<h3 class="card__heading pv-bf__title">' + esc(c.title) + '</h3>' +
            '<div class="tech-badge-container">' +
              specs.map(function (t) { return '<span class="tech-badge-item">' + esc(t) + '</span>'; }).join('') +
            '</div>' +
            '<div class="pv-bf__price" data-price>&nbsp;</div>' +
          '</div>' +
        '</a>' +
      '</div>';
    return li;
  }

  function observe(grid) {
    var load = function (el) {
      var slot = el.querySelector('[data-price]');
      fetch('/products/' + el.dataset.handle + '.js')
        .then(function (r) {
          if (r.status === 404) { el.remove(); return null; }
          return r.ok ? r.json() : null;
        })
        .then(function (p) {
          if (!p || !slot) return;
          slot.innerHTML = '<strong>' + Math.round(p.price / 100).toLocaleString(SV ? 'sv-SE' : 'nb-NO') +
                           ' kr</strong> <small>' + (SV ? 'inkl. moms' : 'inkl. mva') + '</small>';
        })
        .catch(function () {});
    };
    if (!('IntersectionObserver' in window)) {
      grid.querySelectorAll('.pv-bf__item').forEach(load);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.unobserve(e.target); load(e.target); }
      });
    }, { rootMargin: '200px' });
    grid.querySelectorAll('.pv-bf__item').forEach(function (el) { io.observe(el); });
  }
})();
